import site, { withBase } from "../../siteInfo";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <img src={withBase("/logo.png")} alt="" width="56" height="56" />
          <h2>Rao Lokram Charitable Trust</h2>
          <p>25-bed charitable hospital. Sector 10A, Gurugram.</p>
        </div>
        <div>
          <h3>On this site</h3>
          <ul>
            <li><a href={withBase("/#about")}>About</a></li>
            <li><a href={withBase("/#services")}>Services</a></li>
            <li><a href={withBase("/#doctors")}>Doctors</a></li>
            <li><a href={withBase("/blog/")}>Health guides</a></li>
            <li><a href={withBase("/sitemap/")}>Sitemap</a></li>
            <li><a href={withBase("/#visit")}>Visit</a></li>
          </ul>
        </div>
        <div>
          <h3>Desk</h3>
          <ul>
            <li><a href={`tel:${site.phoneTel}`}>{site.phoneDisplay}</a></li>
            <li><a href={`tel:${site.phoneAltTel}`}>{site.phoneAltDisplay}</a></li>
            <li><a href={`mailto:${site.email}`}>{site.email}</a></li>
            <li>{site.hours}</li>
          </ul>
        </div>
        <div>
          <h3>Social</h3>
          <ul>
            <li><a href={site.instagram}>Instagram</a></li>
            <li><a href={site.facebook}>Facebook</a></li>
            <li><a href={site.youtube}>YouTube</a></li>
          </ul>
        </div>
      </div>
      <div className="wrap fine">
        <p>
          © {new Date().getFullYear()} Rao Lokram Charitable Trust. Health guides are general education,
          not a diagnosis or a prescription. Hospital photographs are ours. Other photographs are
          illustrative images from Unsplash and are not pictures of this building.
        </p>
      </div>
      <a
        className="whatsapp-float"
        href={site.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message the hospital desk on WhatsApp"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20.5 3.5A11 11 0 0 0 2.1 16.8L1 23l6.4-1.1A11 11 0 0 0 20.5 3.5zm-8.5 17a9.1 9.1 0 0 1-4.6-1.3l-.3-.2-3.8.6.6-3.7-.2-.3A9.1 9.1 0 1 1 12 20.5zm5-6.8c-.3-.1-1.6-.8-1.8-.9s-.4-.1-.6.1-.7.9-.8 1-.3.2-.6.1a7.4 7.4 0 0 1-2.2-1.4 8.2 8.2 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.4-.5.2-.3a.5.5 0 0 0 0-.5c0-.1-.6-1.4-.8-1.9s-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4.1 15 15 0 0 0 1.5.6 3.6 3.6 0 0 0 1.7.1 2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.6-.3z" />
        </svg>
        <span>WhatsApp</span>
      </a>
    </footer>
  );
};

export default Footer;
